import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import conciergeApiClient from "Services/Apis/Concierge/conciergeApiClient";

export const approveProposedQuotationThunk = createAsyncThunk(
  "approveProposedQuotationSlice/approveProposedQuotationThunk",
  async (approval, { getState, rejectWithValue }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const config = { headers };

    const { withTerm, solicitationId, quotationId, quotationProductIds, note } = approval;

    const body = {
      redemptionQuoteId: quotationId,
      products: quotationProductIds,
      note,
      withTerm
    };

    if (withTerm) body.fileUrl = approval.fileUrl;

    const reqUrl = withTerm
      ? `/Redemption/${solicitationId}/approve-quotation-with-term`
      : `/Redemption/${solicitationId}/approve-quotation`;

    try {
      const { data } = await conciergeApiClient.post(reqUrl, body, config);
      return data;
    }
    catch (error) {
      const payload = {
        responseData: error.response?.data,
        requestData: {
          url: reqUrl,
          headers,
          body,
        }
      }

      return rejectWithValue(payload);
    }
  }
);

const initialState = {
  approvalData: null,
  isApprovalLoading: false,
  approvalHasError: false,
  errorsApproval: null
};

const approveProposedQuotationSlice = createSlice({
  name: "ApproveQuotationWithTerm",
  initialState,
  reducers: {
    resetApproveProposedQuotationData: (state) => {
      state.approvalData = null;
      state.isApprovalLoading = false;
      state.approvalHasError = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(approveProposedQuotationThunk.pending, (state) => {
      state.approvalData = null;
      state.isApprovalLoading = true;
      state.approvalHasError = false;
    });

    builder.addCase(approveProposedQuotationThunk.fulfilled, (state, action) => {
      state.approvalData = action.payload;
      state.isApprovalLoading = false;
      state.approvalHasError = false;
    });

    builder.addCase(approveProposedQuotationThunk.rejected, (state, action) => {
      state.approvalData = null;
      state.approvalHasError = true;
      state.isApprovalLoading = false;
      state.errorsApproval = action.payload;
    });
  },
});

export const { resetApproveProposedQuotationData } = approveProposedQuotationSlice.actions;

export default approveProposedQuotationSlice.reducer;